import { render, staticRenderFns } from "./Caregive.vue?vue&type=template&id=6cebb021"
import script from "./Caregive.vue?vue&type=script&lang=js"
export * from "./Caregive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports